import { createFileRoute } from "@tanstack/react-router";
import { CoworldGrowthPage } from "@/features/office";

export const Route = createFileRoute("/_office/unlisted/office/coworld-growth")(
  {
    head: () => ({ meta: [{ title: "Policy Growth by Coworld | Softmax" }] }),
    component: CoworldGrowthPage,
  },
);
